"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getMerchantReturnPolicySchema = void 0;
const getMerchantReturnPolicySchema = () => {
    return {
        hasMerchantReturnPolicy: {
            '@type': 'MerchantReturnPolicy',
            applicableCountry: 'US',
            returnPolicyCategory: 'https://schema.org/MerchantReturnFiniteReturnWindow',
            merchantReturnDays: 365,
            returnMethod: 'https://schema.org/ReturnByMail',
            returnFees: 'https://schema.org/FreeReturn',
        },
    };
};
exports.getMerchantReturnPolicySchema = getMerchantReturnPolicySchema;
//# sourceMappingURL=merchant-return-policy-schema.js.map